import PropTypes from 'prop-types';

import { Container } from './styles';

const Title = ({ children }) => {
  return <Container>{children}</Container>;
};

Title.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default Title;
